import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/jan-feb-2023/ads/usf.jpg',
      link: 'https://bard.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Shakespeare Festival',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/ufo.jpg',
      link: 'https://utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/u-of-u.jpg',
      link: 'https://osher.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'University of Utah',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/adibs.jpg',
      link: 'https://www.adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Adibs Rug Gallery',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Tuacahn Amphitheatre',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/jerry-seiner.jpg',
      link: 'https://www.jerryseinercadillac.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Jerry Seiner Cadillac',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/william-call.jpg',
      link: 'https://www.williamcall.net/fantasy/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'William Call',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/hamilton-park.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/minky-couture.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Minky Couture',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      image: '/jan-feb-2023/ads/ufirst.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
  ];
  // useState fixes the issue with the flicking multiple images.
  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
